<template>
  <div>
    <div class="header">
      <div>
        <h4 class="title">
          {{ title }}
        </h4>
        <h6 v-if="subTitle" class="sub-title">
          {{ subTitle }}
        </h6>
      </div>
    </div>
    <router-view @sub-title="setSubTitle" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: 'จัดการ Label',
      subTitle: null
    }
  },
  methods: {
    setSubTitle(data) {
      this.subTitle = data
    },
  }
}
</script>

<style lang="css" scoped>
.header {
  border-bottom: 1px solid #efefef;
}

.header .title {
  margin: 0;
}

.header .sub-title {
  color: #606266;
  margin: 0;
  margin-top: .25rem;
}
</style>
